import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { COUPON_PAGE_NAME } from '../../constants/service/app/couponConstants';
import { CouponIssueHistoryListWrap } from '../../views/coupon-v2/issueHistory/CouponIssueHistoryListWrap';

/**
 *  쿠폰 발급 내역 리스트 페이지
 */
const CouponIssueHistoryList = () => {
  return (
    <PageTemplate pageName={COUPON_PAGE_NAME.COUPON_ISSUE_HISTORY_LIST}>
      <CouponIssueHistoryListWrap />
    </PageTemplate>
  );
};

export default CouponIssueHistoryList;
